<template>
  <q-img
    :src="data?.thumbnail_url"
    :alt="data ? `Watch ${data.title} by ${data.author_name}` : undefined"
    ratio="1.7777"
    no-spinner
    @click="dialog({
      component: LazyDialogVideo,
      componentProps: {
        url: embedUrl ?? item.url,
      },
    })"
  >
    <div class="flex flex-center absolute-full no-padding">
      <q-icon
        :name="mdiPlay"
        color="primary"
        size="xl"
      />
    </div>
  </q-img>
</template>

<script lang="ts" setup>
import { mdiPlay } from '@quasar/extras/mdi-v7';
import { LazyDialogVideo } from '#components';

const props = defineProps({
  item: {
    type: Object as PropType<{ url: string }>,
    required: true,
  },
});

const { dialog } = useQuasar();

const { supported, id, provider, oembed, url: embedUrl } = useVideoEmbed(props.item.url);

const { data } = useAsyncData(
  `oembed_${provider?.name}_${id}`,
  () => oembed(),
  {
    lazy: true,
    immediate: supported,
    getCachedData: getCachedPayload,
  },
);
</script>
